var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.47,259.82a31.2,31.2,0,0,1-7.05,4.44L395,272l-12.59,2.16-3-7.14a31.69,31.69,0,0,1-8.13-1.84l-5.74,5.16-10.43-7.38,3-7.14a30.85,30.85,0,0,1-4.44-7l-7.72-.41-2.15-12.59,7.13-3a31.3,31.3,0,0,1,1.85-8.13l-5.17-5.74L355,208.48l7.13,3a31.07,31.07,0,0,1,7.05-4.44l.41-7.72,12.6-2.15,2.95,7.13a31.3,31.3,0,0,1,8.13,1.85l5.74-5.17,10.44,7.39-3,7.13a31.42,31.42,0,0,1,4.44,7l7.71.41,2.16,12.6-7.14,2.95a31.69,31.69,0,0,1-1.84,8.13l5.16,5.74-7.38,10.43-7.14-2.95ZM393.16,244a13.71,13.71,0,1,0-19.11,3.27A13.7,13.7,0,0,0,393.16,244Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,244a10.16,10.16,0,0,1-2.18,2.6,13.82,13.82,0,0,1-14.86,2.23,14.08,14.08,0,0,1-5.7-4.73,14.13,14.13,0,0,1-2.53-7.77,14,14,0,0,1,9.63-13.61,14,14,0,0,1,8.17-.2,13.94,13.94,0,0,1,9.62,9.37,13.74,13.74,0,0,1-.42,9.19,10.36,10.36,0,0,1-1.73,2.92,31.35,31.35,0,0,0,1.45-3,13.7,13.7,0,0,0,.16-8.91,13.24,13.24,0,0,0-3.19-5.28,13.42,13.42,0,0,0-6.08-3.56,13.37,13.37,0,0,0-7.74.23,13.3,13.3,0,0,0-9.1,12.86,12.62,12.62,0,0,0,.66,3.94,12.41,12.41,0,0,0,1.7,3.44,13.51,13.51,0,0,0,5.37,4.55,13.37,13.37,0,0,0,6.05,1.25,13.66,13.66,0,0,0,8.34-3.12A33.2,33.2,0,0,0,393.16,244Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.47,259.82a2.45,2.45,0,0,1,.46.16l1.36.53,5.37,2.15-.15,0,7.32-10.47v.25l-5.18-5.73-.1-.1.05-.13a31,31,0,0,0,1.8-8.07l0-.16.14-.06,7.13-3-.17.31c-.69-4-1.42-8.18-2.18-12.59l.29.25-7.72-.39h-.2l-.08-.18a31.18,31.18,0,0,0-4.4-7l-.13-.16.08-.19c.91-2.21,1.92-4.65,2.94-7.14l.12.42-10.44-7.37.46,0-5.74,5.16-.17.15-.21-.07a31.12,31.12,0,0,0-8-1.82l-.23,0-.09-.21c-.92-2.24-1.93-4.67-3-7.14l.43.24-12.6,2.16.32-.37c-.13,2.44-.27,5.07-.41,7.72v.24l-.21.09a31.15,31.15,0,0,0-7,4.38h0l-.4.06h-.05l-.06,0-.11,0-.22-.09-.45-.19-.9-.37-1.79-.74-3.55-1.48.47-.14-7.39,10.44,0-.49,5.16,5.75.16.17-.08.22a31.38,31.38,0,0,0-1.83,8l0,.23-.21.09-7.14,3,.23-.41q1.1,6.45,2.14,12.6L346,248l7.72.42h.21l.09.2a30.59,30.59,0,0,0,4.38,7l.13.16-.08.19c-1,2.44-2,4.81-3,7.12l-.11-.39,10.42,7.41-.38,0,5.76-5.15.12-.12.16.06a30.87,30.87,0,0,0,8.05,1.85l.16,0,.06.14c1.07,2.6,2,4.94,2.93,7.15l-.25-.14,12.6-2.1-.14.16c.18-3.08.33-5.6.46-7.71v-.08l.07,0a32.19,32.19,0,0,0,5.44-3.1l1.25-.92a3,3,0,0,1,.41-.3,2.52,2.52,0,0,1-.37.35c-.26.22-.66.56-1.22,1a30.1,30.1,0,0,1-5.4,3.23l.07-.11c-.1,2.11-.22,4.64-.36,7.72v.14l-.14,0-12.58,2.21-.19,0-.07-.17c-.92-2.21-1.89-4.54-3-7.13l.22.16a31.37,31.37,0,0,1-8.2-1.84l.28-.05-5.73,5.18-.18.16-.19-.14L355,263.19l-.21-.15.1-.24c.95-2.32,1.93-4.69,2.94-7.14l.06.35a31.49,31.49,0,0,1-4.5-7.12l.3.2-7.72-.4h-.28l-.05-.29q-1.07-6.13-2.17-12.59l-.05-.3.27-.11,7.14-3-.23.32a31.14,31.14,0,0,1,1.86-8.23l.07.39-5.17-5.74-.2-.23.18-.25,7.38-10.44.18-.26.29.12,3.55,1.48,1.79.74.9.37.45.19.22.09.12.05.05,0h.05l-.4.06h0a31.89,31.89,0,0,1,7.14-4.49l-.23.34c.14-2.65.28-5.28.41-7.72l0-.31.31,0,12.6-2.16.3-.05.12.29c1,2.46,2,4.9,2.95,7.14l-.32-.23a32.08,32.08,0,0,1,8.22,1.86l-.38.08,5.75-5.16.22-.19.24.17L409.66,208l.23.16-.11.26-3,7.13-.05-.35a31.64,31.64,0,0,1,4.47,7.14l-.27-.19,7.71.42.25,0,0,.24c.75,4.42,1.46,8.63,2.13,12.6l0,.22-.2.09-7.15,2.93.16-.21a32.12,32.12,0,0,1-1.88,8.18l-.05-.23,5.14,5.76.11.12-.1.13-7.44,10.39-.06.08-.09,0-5.27-2.25-1.35-.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.2,164.69a44,44,0,0,1-10,6.28l-.58,10.91-17.81,3.05-4.18-10.1a44.45,44.45,0,0,1-11.49-2.6l-8.12,7.3L323.3,169.09,327.48,159a44,44,0,0,1-6.27-10l-10.91-.58-3.05-17.81,10.09-4.17A44.54,44.54,0,0,1,320,115l-7.3-8.11L323.09,92.1l10.08,4.18a44.76,44.76,0,0,1,10-6.27l.58-10.91,17.82-3,4.17,10.1a44,44,0,0,1,11.49,2.6l8.12-7.3,14.75,10.44L395.89,102a44.28,44.28,0,0,1,6.28,10l10.91.58,3.05,17.81L406,134.51a44.36,44.36,0,0,1-2.6,11.49l7.3,8.12-10.44,14.75-10.09-4.18ZM377,142.36A19.39,19.39,0,1,0,350,147,19.4,19.4,0,0,0,377,142.36Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5,161.41a41.91,41.91,0,0,1,6.46,9.07l10.32,0,3.84,16.65-9.3,4.48a41.52,41.52,0,0,1-1.84,11l7.33,7.27-9.06,14.48-9.74-3.4a41.67,41.67,0,0,1-9.07,6.46l0,10.33-16.64,3.83-4.49-9.3a41.59,41.59,0,0,1-11-1.84l-7.27,7.33-14.48-9.06,3.4-9.74a41.67,41.67,0,0,1-6.46-9.07l-10.32,0L84.4,193.24l9.3-4.49a42,42,0,0,1,1.84-11l-7.33-7.27L97.27,156l9.74,3.4a41.67,41.67,0,0,1,9.07-6.46l0-10.32,16.65-3.84,4.48,9.3a41.93,41.93,0,0,1,11,1.84l7.27-7.32,14.48,9-3.4,9.74ZM146.13,175A18.32,18.32,0,1,0,152,200.29,18.32,18.32,0,0,0,146.13,175Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.56,91.41a23.54,23.54,0,0,1,3.57,5l5.72,0,2.12,9.22-5.15,2.48a23.16,23.16,0,0,1-1,6.08l4.05,4-5,8-5.39-1.88a23,23,0,0,1-5,3.57l0,5.72-9.22,2.12-2.48-5.14a23.53,23.53,0,0,1-6.08-1l-4,4.05-8-5,1.89-5.4a23.1,23.1,0,0,1-3.58-5l-5.71,0L131.1,109l5.15-2.48a23.11,23.11,0,0,1,1-6.08l-4.06-4,5-8,5.39,1.88a23.59,23.59,0,0,1,5-3.58l0-5.71,9.22-2.13L160.32,84a23.18,23.18,0,0,1,6.08,1l4-4.06,8,5-1.88,5.39ZM165.28,99a10.14,10.14,0,1,0,3.22,14A10.14,10.14,0,0,0,165.28,99Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52,102.33a18.78,18.78,0,0,1,2.9,4.07l4.63,0,1.72,7.47-4.17,2a18.63,18.63,0,0,1-.82,4.93l3.28,3.26L109,130.54,104.63,129a19.13,19.13,0,0,1-4.07,2.9l0,4.63-7.47,1.72-2-4.17a19.06,19.06,0,0,1-4.93-.83l-3.26,3.29-6.49-4.06,1.52-4.37a19.08,19.08,0,0,1-2.89-4.07H70.41l-1.72-7.46,4.17-2a19,19,0,0,1,.83-4.93l-3.29-3.26,4.07-6.5,4.37,1.53a18.48,18.48,0,0,1,4.06-2.9V93.91l7.46-1.72,2,4.17a19,19,0,0,1,4.93.82l3.26-3.28,6.5,4.06-1.53,4.37Zm-9.13,6.11A8.22,8.22,0,1,0,99,119.77,8.23,8.23,0,0,0,96.39,108.44Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.39,108.44a3.12,3.12,0,0,1,.46.26,6.42,6.42,0,0,1,1.17,1,8.08,8.08,0,0,1,2.37,5,8.38,8.38,0,0,1-.51,3.85,8.47,8.47,0,0,1-2.64,3.58,8,8,0,0,1-2.11,1.21,7.89,7.89,0,0,1-2.47.58,8.54,8.54,0,0,1-5.13-1.26,8.42,8.42,0,0,1-3.37-4.06,8.28,8.28,0,0,1-.57-2.47,8.19,8.19,0,0,1,.17-2.43,8.4,8.4,0,0,1,2.07-3.94,8.3,8.3,0,0,1,8.75-2.2,6.64,6.64,0,0,1,1.37.64,2.73,2.73,0,0,1,.44.3c0,.06-.64-.36-1.87-.75a8.23,8.23,0,0,0-5.33.21,8.06,8.06,0,0,0-5,5.84,7.61,7.61,0,0,0-.14,2.29,7.75,7.75,0,0,0,.55,2.33,7.94,7.94,0,0,0,3.17,3.8,8.08,8.08,0,0,0,4.81,1.19,7.61,7.61,0,0,0,2.33-.53,7.34,7.34,0,0,0,2-1.13,8,8,0,0,0,3.08-7,8.17,8.17,0,0,0-2.14-4.88C97,108.85,96.35,108.49,96.39,108.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52,102.33s0-.09.08-.28l.27-.83,1.1-3.29,0,.1-6.52-4,.17,0-3.25,3.3-.06.07-.09,0a18.81,18.81,0,0,0-4.89-.8h-.1l-.05-.1-2-4.16.2.1-7.46,1.74.16-.2c0,1.43,0,3,0,4.63v.13l-.11.06a18.87,18.87,0,0,0-4,2.87l-.1.1-.13,0-4.37-1.52.27-.09-4,6.5,0-.3,3.29,3.25.11.11,0,.14a18.37,18.37,0,0,0-.81,4.86v.16l-.14.06-4.17,2,.14-.29c.55,2.36,1.13,4.9,1.73,7.47l-.26-.2,4.63,0h.16l.08.14a18.13,18.13,0,0,0,2.85,4h0c0,.11,0-.27.06.26h0v.06l0,.06,0,.14-.09.28-.19.55-.39,1.09c-.25.73-.51,1.46-.76,2.18l-.11-.3,6.5,4.06-.32,0c1.1-1.11,2.19-2.2,3.26-3.29l.11-.11.15.05a18.45,18.45,0,0,0,4.86.81h.15l.07.14,2,4.17-.28-.13,7.46-1.72-.18.24c0-1.57,0-3.12,0-4.63v-.15l.12-.06a18.91,18.91,0,0,0,4-2.86l.1-.09.12.05,4.37,1.53-.25.09,4.07-6.49,0,.25-3.27-3.27-.09-.08,0-.11a18.91,18.91,0,0,0,.83-4.88v-.1l.1,0,4.18-2-.09.17c-.65-2.89-1.21-5.36-1.68-7.47l.11.09-4.63,0h0l0,0a19.87,19.87,0,0,0-2-3.15l-.6-.72-.19-.24a1.63,1.63,0,0,1,.23.21c.14.15.35.38.62.7a17.22,17.22,0,0,1,2.12,3.12l-.07,0,4.63,0h.09l0,.1c.5,2.1,1.08,4.57,1.76,7.45l0,.12-.11.06-4.16,2,.09-.14a19.21,19.21,0,0,1-.81,5l0-.19,3.29,3.26.12.11-.09.13-4,6.51-.09.15-.16-.06-4.37-1.52.22,0a18.9,18.9,0,0,1-4.11,2.94l.12-.21c0,1.52,0,3.06,0,4.64v.19l-.19,0-7.46,1.73-.19,0-.09-.17c-.66-1.38-1.33-2.76-2-4.17l.22.14a19.09,19.09,0,0,1-5-.83l.26-.07-3.26,3.29-.15.15-.17-.11-6.5-4.06-.18-.11.07-.2c.25-.72.51-1.45.76-2.18l.38-1.1.2-.54.09-.28.05-.14,0-.07,0,0v0h0c.11.53,0,.14,0,.26h0a18.86,18.86,0,0,1-2.93-4.12l.23.14H70.21l0-.2c-.59-2.57-1.17-5.1-1.72-7.47l0-.19.18-.09,4.18-2-.15.22a19.22,19.22,0,0,1,.84-5l.06.25c-1.13-1.14-2.26-2.25-3.28-3.27l-.13-.14.1-.16,4.07-6.49.1-.16.17.06,4.37,1.54-.23,0a19.33,19.33,0,0,1,4.12-2.92l-.11.19c0-1.62,0-3.2,0-4.63v-.16l.16,0L90.31,92l.15,0,.06.14c.7,1.46,1.38,2.87,2,4.18l-.15-.1a18.92,18.92,0,0,1,5,.85l-.16,0,3.28-3.27.07-.08.09.06,6.47,4.1.06,0,0,.06c-.51,1.39-.9,2.47-1.18,3.22l-.31.84A1.54,1.54,0,0,1,105.52,102.33Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.66,445.87l-132.87-.61A28.94,28.94,0,0,1,172,416.19l1.4-333.08a28.94,28.94,0,0,1,29.08-28.82l132.86.61A28.94,28.94,0,0,1,364.14,84l-1.41,333.09A28.93,28.93,0,0,1,333.66,445.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.14,66.39l-25.76-.11a6.39,6.39,0,0,0-6.28,6.51l0,4.67A6.39,6.39,0,0,1,296.8,84l-50.21-.23a6.41,6.41,0,0,1-6.23-6.57l0-4.67a6.41,6.41,0,0,0-6.23-6.57l-9.06,0-22.54-.11A20.28,20.28,0,0,0,182.18,86l-1.37,325.11A20.26,20.26,0,0,0,201,431.44l132.6.61a20.26,20.26,0,0,0,20.36-20.18l1.38-325.12A20.29,20.29,0,0,0,335.14,66.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.57,
    y: 153.15,
    width: 71.57,
    height: 71.57,
    rx: 9.76,
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.68 179.18 217.41 182.68 221.27 183.24 218.47 185.96 219.13 189.8 215.68 187.99 212.23 189.8 212.89 185.96 210.1 183.24 213.96 182.68 215.68 179.18",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.18 144.53 328.51 147.23 331.5 147.67 329.34 149.77 329.85 152.74 327.18 151.34 324.51 152.74 325.02 149.77 322.86 147.67 325.85 147.23 327.18 144.53",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.56 209.38 325.71 210.95 327.66 210.89 326.53 212.47 327.19 214.31 325.33 213.72 323.79 214.91 323.78 212.96 322.17 211.87 324.02 211.25 324.56 209.38",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,156a1.83,1.83,0,1,1,1.82-1.82A1.83,1.83,0,0,1,214.36,156Zm0-2.65a.83.83,0,1,0,.82.83A.83.83,0,0,0,214.36,153.32Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.54,181.2a1.83,1.83,0,1,1,1.82-1.82A1.83,1.83,0,0,1,317.54,181.2Zm0-2.65a.83.83,0,1,0,.82.83A.83.83,0,0,0,317.54,178.55Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.72,142.68a1.83,1.83,0,1,1,1.83-1.82A1.82,1.82,0,0,1,293.72,142.68Zm0-2.65a.83.83,0,1,0,.83.83A.83.83,0,0,0,293.72,140Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.43,
    cy: 213.47,
    r: 1.33,
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.87,232.39a1.33,1.33,0,1,1-1.33-1.33A1.32,1.32,0,0,1,266.87,232.39Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.69,
    cy: 127.41,
    r: 1.33,
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.89,333v-5.62h1v5.58c0,2.32,1.09,3.39,3,3.39s3-1.07,3-3.39v-5.58h1V333c0,2.82-1.51,4.27-4,4.27S238.89,335.8,238.89,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,330.73c0,2.08-1.51,3.34-4,3.34H251.1v3.1h-1v-9.81h3.67C256.23,327.36,257.74,328.63,257.74,330.73Zm-1,0c0-1.57-1-2.47-3-2.47H251.1v4.9h2.61C255.67,333.16,256.71,332.27,256.71,330.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,327.36h4c3.14,0,5.25,2,5.25,4.91s-2.11,4.9-5.25,4.9h-4Zm3.94,8.91c2.6,0,4.28-1.65,4.28-4a3.93,3.93,0,0,0-4.28-4H261v8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55,334.55h-5.46l-1.18,2.62h-1.08l4.49-9.81h1l4.48,9.81h-1.09Zm-.38-.84-2.35-5.27-2.35,5.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,328.26h-3.45v-.9h7.93v.9h-3.45v8.91h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,336.27v.9H289v-9.81h6.72v.9H290v3.49h5.07v.88H290v3.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,176.4a15.09,15.09,0,0,1,2.88,2.82l3.68-.67,2.43,5.69-3,2.19a15.17,15.17,0,0,1,0,4l3.08,2.12-2.31,5.75-3.69-.6a15.2,15.2,0,0,1-2.83,2.89l.68,3.68-5.7,2.43-2.19-3a14.69,14.69,0,0,1-4,.05l-2.13,3.07-5.74-2.3.59-3.69a15.15,15.15,0,0,1-2.88-2.83l-3.68.67L252.78,193l3-2.19a15.17,15.17,0,0,1,0-4l-3.08-2.12,2.31-5.75,3.69.6a15.1,15.1,0,0,1,2.82-2.88l-.67-3.68,5.69-2.43,2.2,3a15.51,15.51,0,0,1,4-.05l2.13-3.07,5.74,2.3-.59,3.7Zm-6.4,6.16a6.64,6.64,0,1,0,3.69,8.63A6.64,6.64,0,0,0,273.64,182.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,182.56a4.89,4.89,0,0,1,1.47.73,6.6,6.6,0,0,1,2.58,3.63,6.74,6.74,0,0,1-1.45,6.34,6.56,6.56,0,0,1-1.5,1.26,6.43,6.43,0,0,1-1.88.8,6.79,6.79,0,0,1-7.49-3,6.81,6.81,0,0,1-1-3.83,6.82,6.82,0,0,1,1.08-3.42,6.69,6.69,0,0,1,6.63-3,5,5,0,0,1,1.57.49,13.8,13.8,0,0,0-1.59-.34,6.6,6.6,0,0,0-4.22.92,6.46,6.46,0,0,0-3.12,5.36,6.46,6.46,0,0,0,1,3.62,6.47,6.47,0,0,0,8.86,2.09A6.12,6.12,0,0,0,276,193a6.48,6.48,0,0,0,1.45-6,6.6,6.6,0,0,0-2.41-3.58A15.76,15.76,0,0,0,273.64,182.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,176.4a.87.87,0,0,1,0-.24c0-.17.06-.4.1-.7.09-.64.23-1.56.41-2.76l0,.06-5.76-2.27.12,0-2.12,3.09,0,.05h-.07a15.48,15.48,0,0,0-4,.06h-.07l-.05-.06c-.68-.94-1.42-2-2.2-3l.17,0-5.69,2.44.09-.16.68,3.68,0,.09-.08.06a14.6,14.6,0,0,0-2.79,2.86l-.06.08-.1,0-3.69-.59.19-.1c-.73,1.8-1.51,3.75-2.3,5.74l-.07-.21,3.08,2.13.09.06v.11a14.78,14.78,0,0,0,0,4l0,.11-.09.07-3,2.19.06-.22c.77,1.8,1.6,3.73,2.43,5.69l-.21-.11,3.68-.68.12,0,.07.09a15,15,0,0,0,2.84,2.79h0c0,.08-.07-.18.08.19h0V201l0,.11,0,.24-.07.46-.15.93c-.1.61-.2,1.23-.29,1.84l-.12-.21,5.74,2.31-.22.07,2.12-3.08.07-.09h.11a14.8,14.8,0,0,0,4,0h.11l.06.09,2.19,3-.22-.06,5.7-2.42-.11.19c-.22-1.25-.44-2.48-.66-3.68l0-.11.08-.06a15.35,15.35,0,0,0,2.8-2.84l.06-.08h.09l3.7.6-.18.1,2.32-5.74.06.17L286,190.58l-.06-.05v-.08a15.22,15.22,0,0,0,0-4v-.07l.06,0,3-2.18,0,.13-2.4-5.7.09,0-3.68.65h0l0,0a15.12,15.12,0,0,0-2.07-2.21l-.57-.49-.19-.16.21.13c.13.1.33.25.59.47a15.29,15.29,0,0,1,2.13,2.18l-.06,0,3.67-.7h.07l0,.06,2.45,5.69,0,.08-.08.05-3,2.2.05-.12a15.29,15.29,0,0,1,.06,4.07l-.06-.12,3.08,2.11.1.07-.05.11c-.72,1.82-1.48,3.72-2.29,5.75l0,.11-.12,0-3.7-.58.16-.07a15.42,15.42,0,0,1-2.85,2.92l.06-.16c.22,1.2.45,2.43.68,3.67l0,.14-.12.06-5.69,2.43-.14.06-.08-.12c-.72-1-1.46-2-2.2-3l.18.08a15.54,15.54,0,0,1-4.09,0l.18-.08-2.12,3.08-.09.13-.14-.06-5.74-2.31-.14-.05,0-.15.3-1.84.14-.93.08-.46,0-.24v-.2h0c.15.36,0,.1.08.18h0a15.8,15.8,0,0,1-2.91-2.86l.18.07-3.68.67-.15,0-.06-.14-2.42-5.7-.06-.13.12-.09,3-2.19-.07.18a15.19,15.19,0,0,1,0-4.09l.07.17-3.07-2.13-.12-.08.06-.13c.8-2,1.58-3.94,2.31-5.74l0-.12.14,0,3.69.6-.16.06a15.2,15.2,0,0,1,2.86-2.91l-.06.15c-.23-1.28-.46-2.54-.67-3.68l0-.12.11,0,5.7-2.42.1,0,.06.09,2.19,3-.12-.05a15.37,15.37,0,0,1,4.06,0l-.1,0,2.14-3.07,0-.06.07,0,5.73,2.34.05,0v0c-.2,1.19-.36,2.1-.47,2.74-.06.3-.1.53-.13.7S280,176.39,280,176.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.62,
    y: 247.77,
    width: 73.08,
    height: 52.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.62,
    y: 247.77,
    width: 63.71,
    height: 52.86,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.62 247.77 209.31 236.46 237.97 236.46 248.61 247.77 220.62 247.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.32 247.77 297.33 236.46 333.02 236.46 317.7 247.77 284.32 247.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.32,247.77c0,.14-14.26.26-31.85.26s-31.85-.12-31.85-.26,14.25-.26,31.85-.26S284.32,247.62,284.32,247.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.45,
    y: 356.88,
    width: 127.79,
    height: 10.4,
    rx: 5.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.45,
    y: 356.88,
    width: 67.8,
    height: 10.4,
    rx: 5.08,
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.9,392.84c0,2.13-1.48,3.79-4.54,3.79a6.46,6.46,0,0,1-4.5-1.61l.63-1a5.43,5.43,0,0,0,3.85,1.45c2.13,0,3.25-1,3.25-2.56s-1-2.61-4.18-2.61h-2.67l.64-6.28h6.86v1.14h-5.73l-.43,4h1.61C260.47,389.13,261.9,390.62,261.9,392.84Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.94,392.84c0,2.13-1.48,3.79-4.54,3.79a6.46,6.46,0,0,1-4.5-1.61l.63-1a5.43,5.43,0,0,0,3.85,1.45c2.13,0,3.25-1,3.25-2.56s-1-2.61-4.18-2.61h-2.67l.64-6.28h6.86v1.14h-5.73l-.43,4h1.61C270.51,389.13,271.94,390.62,271.94,392.84Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,387.31c0-2,1.15-3.4,2.83-3.4s2.83,1.34,2.83,3.4-1.17,3.4-2.83,3.4S273.21,389.35,273.21,387.31Zm4.76,0c0-1.63-.77-2.6-1.93-2.6s-1.93,1-1.93,2.6.75,2.59,1.93,2.59S278,388.94,278,387.31Zm5.66-3.31h1.05l-8.55,12.53h-1.06Zm-2.74,9.22c0-2,1.16-3.41,2.83-3.41s2.82,1.37,2.82,3.41-1.14,3.4-2.82,3.4S280.89,395.26,280.89,393.22Zm4.76,0c0-1.62-.75-2.6-1.93-2.6s-1.94,1-1.94,2.6.77,2.59,1.94,2.59S285.65,394.83,285.65,393.22Z",
    style: {
      fill: "#990E3F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.2,445.58c0,.14-105.31.26-235.19.26s-235.21-.12-235.21-.26,105.29-.26,235.21-.26S485.2,445.43,485.2,445.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.36,434.16l2.88,11,32.19-.29s-4.41-3.33-20.58-3.09l-1.57-7.62Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.27,309.9l-24.15,2.28L129.31,315a26.6,26.6,0,0,0-11.17,6.41L86.53,351.69l-5.77-47.13L65,305.94l2.64,60.66a18.06,18.06,0,0,0,17.21,12.58A18.66,18.66,0,0,0,97.53,374L120,352.79l-2.23,27.92-7.74,17.35,55.25,31.2s6.49-32.12,10-54.34c2.82-18,4.25-57.13,4.25-57.13Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,317.23s12.21,4.53,15.17,14.1c2.62,8.48,11.36,56.2,11.36,56.2L213.31,438l-18.16.69-20.91-86.06Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.35,379.47c-.15,0,.66-9.68,1.8-21.59s2.19-21.55,2.33-21.54-.67,9.68-1.81,21.59S117.49,379.49,117.35,379.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.56,355.74a1.87,1.87,0,0,1-.16.47l-.55,1.31a20.88,20.88,0,0,1-1,2c-.42.78-.85,1.69-1.46,2.62-.29.47-.6,1-.91,1.48s-.71,1-1.08,1.55c-.73,1.08-1.63,2.15-2.56,3.29A49.05,49.05,0,0,1,135,380.31c-1.32.65-2.56,1.29-3.78,1.75-.61.24-1.18.5-1.75.7l-1.66.55c-1,.38-2,.6-2.87.83a19.72,19.72,0,0,1-2.21.48l-1.4.24a1.72,1.72,0,0,1-.5.05,1.71,1.71,0,0,1,.48-.15l1.38-.33c.6-.13,1.34-.31,2.17-.57s1.81-.49,2.84-.89l1.62-.59c.57-.2,1.13-.47,1.73-.72,1.21-.48,2.43-1.12,3.73-1.77a54.93,54.93,0,0,0,7.91-5.17,56.46,56.46,0,0,0,6.83-6.53c.92-1.12,1.83-2.17,2.57-3.24.37-.52.76-1,1.09-1.51l.94-1.46c.62-.91,1.07-1.8,1.51-2.56a22,22,0,0,0,1-2l.64-1.27C157.46,355.88,157.54,355.73,157.56,355.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.76,384.37a3.71,3.71,0,0,1-2.23-4.44,6.37,6.37,0,0,1,3.6-3.92,25.69,25.69,0,0,1,5.26-1.56,44.14,44.14,0,0,0,20.54-11.53c.53-.52,1.27-1.09,1.92-.74.87.48.32,1.8-.32,2.56a66.37,66.37,0,0,1-29.33,19.67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.92,373a4.81,4.81,0,0,1-.37-1c-.2-.67-.48-1.65-.8-2.86-.66-2.41-1.5-5.77-2.33-9.49s-1.52-7.12-2-9.58c-.22-1.24-.39-2.23-.49-2.93a4,4,0,0,1-.1-1.08,4.53,4.53,0,0,1,.3,1c.18.8.4,1.76.66,2.89.56,2.57,1.29,5.88,2.1,9.54s1.6,7,2.18,9.52c.26,1.14.47,2.1.65,2.9A4.18,4.18,0,0,1,178.92,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,310.47a5.9,5.9,0,0,1-.46-2.38,5.7,5.7,0,0,1,.06-2.43,5.9,5.9,0,0,1,.46,2.38A5.7,5.7,0,0,1,67.76,310.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.38,310.61a6.67,6.67,0,0,1-.39-2.53,6.56,6.56,0,0,1,.13-2.56,6.24,6.24,0,0,1,.39,2.53A6.14,6.14,0,0,1,72.38,310.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,310.32a7.86,7.86,0,0,1-.42-2.82,8.09,8.09,0,0,1,.1-2.86,8.22,8.22,0,0,1,.42,2.83A8,8,0,0,1,77,310.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.86,358.93a16.32,16.32,0,0,1,.17-4.17,16.87,16.87,0,0,1,.68-4.12,16.32,16.32,0,0,1-.17,4.17A16.87,16.87,0,0,1,85.86,358.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.14,433.46a6.9,6.9,0,0,1,.7,2.53,7,7,0,0,1,.19,2.62,12.84,12.84,0,0,1-.89-5.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.11,433.45a5.69,5.69,0,0,1,.64,2.3,5.36,5.36,0,0,1,.13,2.38,5.69,5.69,0,0,1-.64-2.3A5.54,5.54,0,0,1,204.11,433.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.77,432.88a8.74,8.74,0,0,1,.6,2.59,8.29,8.29,0,0,1,.28,2.65,6.15,6.15,0,0,1-.8-2.56A6,6,0,0,1,209.77,432.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,323.11c0,.1-1.27,0-3.24.43a15.09,15.09,0,0,0-11.25,9.83c-.67,1.89-.77,3.16-.87,3.14a2.65,2.65,0,0,1,0-.89,12.8,12.8,0,0,1,.5-2.37,14.51,14.51,0,0,1,11.54-10.07A12.91,12.91,0,0,1,187,323,2.74,2.74,0,0,1,187.91,323.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.38,343.64a19.29,19.29,0,0,1-3,1.28c-1.88.71-4.52,1.64-7.46,2.55s-5.64,1.66-7.6,2.15a17.92,17.92,0,0,1-3.2.66,22.88,22.88,0,0,1,3.11-1l7.53-2.28,7.5-2.41A22.61,22.61,0,0,1,195.38,343.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.08,378.45a20.59,20.59,0,0,1-3.13.85c-1.95.46-4.65,1.06-7.63,1.69s-5.7,1.17-7.67,1.54a20.23,20.23,0,0,1-3.2.48,20.61,20.61,0,0,1,3.12-.84c2-.46,4.65-1.06,7.64-1.69s5.7-1.18,7.66-1.54A19.72,19.72,0,0,1,203.08,378.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.81,422a17.94,17.94,0,0,1-3,.15c-1.85.05-4.41.13-7.22.29s-5.37.38-7.21.55a21,21,0,0,1-3,.19,15.19,15.19,0,0,1,3-.56c1.83-.26,4.39-.53,7.22-.7s5.39-.18,7.25-.13A14.88,14.88,0,0,1,211.81,422Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.66,381.06a10.76,10.76,0,0,1-2.07-.89l-4.9-2.34-4.91-2.31a12,12,0,0,1-2-1,8.88,8.88,0,0,1,2.15.71c1.29.51,3.06,1.27,5,2.18s3.62,1.8,4.84,2.49A9,9,0,0,1,131.66,381.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.91,387.89a5.87,5.87,0,0,1-1.18-.45l-3.15-1.37c-2.65-1.16-6.33-2.74-10.43-4.38s-7.86-3-10.58-4l-3.22-1.18a6.22,6.22,0,0,1-1.17-.49,5.05,5.05,0,0,1,1.23.3c.78.22,1.9.57,3.28,1,2.76.9,6.54,2.24,10.65,3.88s7.78,3.28,10.39,4.53c1.31.63,2.37,1.15,3.08,1.52A5.75,5.75,0,0,1,171.91,387.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,359.47a2.16,2.16,0,0,1-.56-.05l-1.6-.24-5.86-.95c-5-.8-11.79-1.9-19.36-3s-14.44-2-19.42-2.69l-5.88-.78-1.6-.23a2.19,2.19,0,0,1-.56-.12,3.52,3.52,0,0,1,.57,0l1.61.14c1.4.12,3.42.33,5.91.61,5,.56,11.86,1.43,19.44,2.54s14.41,2.27,19.35,3.17c2.47.45,4.46.83,5.84,1.11l1.58.34A1.92,1.92,0,0,1,175,359.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.78,329.46c0,.14-10.84-1.36-24.17-3.35s-24.11-3.72-24.09-3.86,10.84,1.36,24.17,3.35S172.8,329.32,172.78,329.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,355.71a26.63,26.63,0,0,1-1.54-3.25l-3.51-7.92c-1.38-3-2.62-5.73-3.6-7.88a27.47,27.47,0,0,1-1.41-3.3,3.14,3.14,0,0,1,.52.82c.3.54.72,1.33,1.23,2.32,1,2,2.34,4.74,3.73,7.83s2.57,5.92,3.38,8c.41,1,.72,1.87.93,2.46A3.8,3.8,0,0,1,116.1,355.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.56,376.79c-.14,0-1.52-6-3.08-13.49s-2.71-13.56-2.57-13.59,1.52,6,3.08,13.48S94.7,376.76,94.56,376.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.65,344a88.29,88.29,0,0,1-9.37,2.27A89.31,89.31,0,0,1,66.8,348a89.67,89.67,0,0,1,9.37-2.28A90.67,90.67,0,0,1,85.65,344Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.52,316.63a11.58,11.58,0,0,1-2.47.54c-1.53.26-3.66.57-6,.84s-4.5.44-6.06.53a11.84,11.84,0,0,1-2.52,0,13,13,0,0,1,2.49-.39l6-.69,6-.68A13,13,0,0,1,82.52,316.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65,269.13c.28.56,7.79,39.16,7.79,39.16l-17.7.83-6.86-33.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.44 308.29 100.47 307.44 92.81 269.39 90.41 269.23 98.44 308.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.53,277.57a.92.92,0,1,1-1-.8A.92.92,0,0,1,83.53,277.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,304.66l-.27-5.05,7.57-3.12-3-7a6.11,6.11,0,0,0-8.5-2.91l-3,1.65a8.66,8.66,0,0,0-4.31,5.59,110,110,0,0,0-1.75,12.35",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.63,433.35s-31.12,8.61-32.37,9c-1.87.66-1.56,7.53,1.36,7.42,1.38-.05,23.9.84,26.75.66s11.43-3.56,11.43-3.56Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.67,445.22a31.24,31.24,0,0,0-1.37-3.34A29,29,0,0,0,43.1,439a6.9,6.9,0,0,1,3.57,6.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.91,443.75c-.15,0-.47-1.44-1.3-3.07s-1.8-2.76-1.69-2.87a7.82,7.82,0,0,1,3,5.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,442.94a19.7,19.7,0,0,0-.72-3.29,20.26,20.26,0,0,0-1.7-2.91,5.84,5.84,0,0,1,2.42,6.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4,438.92a5.68,5.68,0,0,1-.33-2.32,10.75,10.75,0,0,1,.31-2.54,11,11,0,0,1,.47-1.44,1.7,1.7,0,0,1,.49-.76.83.83,0,0,1,1.07.05,1.37,1.37,0,0,1,.42.88,5.77,5.77,0,0,1,0,.82,7.45,7.45,0,0,1-.19,1.53,9.06,9.06,0,0,1-1,2.37,6.29,6.29,0,0,1-1.4,1.88c-.07-.05.45-.78,1.07-2.05a9.84,9.84,0,0,0,.82-2.31,7.27,7.27,0,0,0,.15-1.42c0-.48,0-1.08-.29-1.31a.3.3,0,0,0-.41,0,1.29,1.29,0,0,0-.34.54,11.85,11.85,0,0,0-.47,1.38,11.41,11.41,0,0,0-.41,2.43C52.35,438,52.49,438.9,52.4,438.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.44,438.6a4.4,4.4,0,0,1,2-.32,8.9,8.9,0,0,1,2.21.27,4.83,4.83,0,0,1,1.27.47,1.31,1.31,0,0,1,.7,1.42,1.55,1.55,0,0,1-1.12,1.11,2.76,2.76,0,0,1-1.4,0,6.65,6.65,0,0,1-3.46-2.41,12.91,12.91,0,0,1,1.65,1.12,5.69,5.69,0,0,0,1.91.83,2.52,2.52,0,0,0,1.16,0,1,1,0,0,0,.75-.74.8.8,0,0,0-.46-.87,4.82,4.82,0,0,0-1.13-.44,10.87,10.87,0,0,0-2.09-.37C53.22,438.56,52.45,438.68,52.44,438.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.89,445.56a18.12,18.12,0,0,0-.62-2.81,17.09,17.09,0,0,0-1.52-2.44,4.49,4.49,0,0,1,2.14,5.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6,447a6.64,6.64,0,0,1-1.21.57,27.5,27.5,0,0,1-3.46,1.07,49.31,49.31,0,0,1-11.88,1.13c-4.66-.05-8.86-.27-11.91-.39l-3.61-.19a6.51,6.51,0,0,1-1.32-.14,5.85,5.85,0,0,1,1.33-.06l3.61,0,11.9.24a55.51,55.51,0,0,0,11.8-1C61.82,447.66,63.56,446.9,63.6,447Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52,447.7c0,.07-.9-.42-2.33-1.05a10.84,10.84,0,0,0-5.89-1,9.32,9.32,0,0,0-5.09,3,19,19,0,0,1-1.79,1.84,9.38,9.38,0,0,1,1.52-2.09A12.61,12.61,0,0,1,53,446.51a7.4,7.4,0,0,1,3.22-1.36,10.36,10.36,0,0,1,6.12,1.16A8.33,8.33,0,0,1,64.52,447.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.66,424.76s29.44,19.28,30.5,20.08c1.58,1.19-.23,6.9-3,5.91-1.3-.47-26-7.34-28.67-8.37s-9.8-6.87-9.8-6.87Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,440a6.93,6.93,0,0,1,5.29-4.83,29.21,29.21,0,0,0-3,2.06A28.47,28.47,0,0,0,101.4,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.76,437.62a5.79,5.79,0,0,1,1.79-2.9,6,6,0,0,1,2.86-1.85c.08.14-1.21.91-2.48,2.22S98.89,437.69,98.76,437.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,435.92a5.82,5.82,0,0,1,4.19-5.17A20.8,20.8,0,0,0,97.8,433,20.87,20.87,0,0,0,96.11,435.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,432.26c-.07,0,.33-.84.67-2.21a12.31,12.31,0,0,0,.35-2.44,11.92,11.92,0,0,0,0-1.45,1.23,1.23,0,0,0-.16-.62.3.3,0,0,0-.4-.09c-.34.13-.51.71-.67,1.16a7.12,7.12,0,0,0-.29,1.4,10.18,10.18,0,0,0,.08,2.45c.2,1.4.48,2.25.4,2.27a6.11,6.11,0,0,1-.77-2.21,9.57,9.57,0,0,1-.19-2.56,7.81,7.81,0,0,1,.28-1.51c.08-.25.18-.5.29-.77a1.41,1.41,0,0,1,.66-.71.84.84,0,0,1,1,.28,1.69,1.69,0,0,1,.24.87,9.64,9.64,0,0,1,0,1.52,10.4,10.4,0,0,1-.47,2.51A5.46,5.46,0,0,1,97.85,432.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.91,431.94c0,.08-.73-.27-1.91-.56a11,11,0,0,0-2.11-.29,4.87,4.87,0,0,0-1.21.08.8.8,0,0,0-.7.69,1.05,1.05,0,0,0,.49.93,2.52,2.52,0,0,0,1.1.37,5.44,5.44,0,0,0,2.07-.21,13.6,13.6,0,0,1,1.92-.57,5.35,5.35,0,0,1-1.81.92,5.22,5.22,0,0,1-2.23.33,2.76,2.76,0,0,1-1.33-.42,1.54,1.54,0,0,1-.73-1.39,1.32,1.32,0,0,1,1.1-1.15,5.24,5.24,0,0,1,1.35-.06,9.06,9.06,0,0,1,2.19.42A4.44,4.44,0,0,1,97.91,431.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.43,449.68s-.5-.3-.72-1.15a4.29,4.29,0,0,1,.55-3.19,12.93,12.93,0,0,1,1-1.47,5.49,5.49,0,0,1,1-1.07,1.74,1.74,0,0,1,.94-.4c.25,0,.38.05.37.08a2.75,2.75,0,0,0-1.07.6,7,7,0,0,0-.85,1.07c-.3.44-.63.92-.92,1.44a4.56,4.56,0,0,0-.64,2.87A12.62,12.62,0,0,0,116.43,449.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,441.78a4.46,4.46,0,0,1,3.62-4.35c.06.15-1.18.63-2.19,1.86A16.43,16.43,0,0,0,105.86,441.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.73,436.55a9.8,9.8,0,0,1,1.3.89,35.65,35.65,0,0,0,3.63,2.22,47.35,47.35,0,0,0,5.76,2.57c2.23.83,4.73,1.62,7.38,2.38,5.3,1.53,10.09,2.92,13.55,4l4.09,1.26a8.3,8.3,0,0,1,1.48.53,10,10,0,0,1-1.53-.34l-4.14-1.09c-3.49-.95-8.29-2.29-13.6-3.82-2.65-.76-5.16-1.57-7.4-2.43A44.61,44.61,0,0,1,89.48,440a28.07,28.07,0,0,1-3.57-2.39A7.76,7.76,0,0,1,84.73,436.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.64,437a8.36,8.36,0,0,1,2.5-.67,10.33,10.33,0,0,1,6.19.76A7.39,7.39,0,0,1,95,439.31a12.11,12.11,0,0,1,1.38,2.47,9.4,9.4,0,0,1,.82,2.45A20.77,20.77,0,0,1,96,441.94a9.24,9.24,0,0,0-3.93-4.43,10.79,10.79,0,0,0-5.91-.86C84.62,436.81,83.66,437,83.64,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.66,272l1.92,38.89A11.58,11.58,0,0,1,152,323.06h0a11.58,11.58,0,0,1-11.57-11c-.14-2.93-.26-5.37-.3-5.67,0,0-9.94-.45-11.14-10.21-.58-4.72-1-14.53-1.25-23.42A18.33,18.33,0,0,1,144.07,254l.94-.1C155.25,253.37,161.42,261.77,161.66,272Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.11,306.23a22.88,22.88,0,0,0,12.35-5s-2.24,7.37-12.09,7.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.86,278.85a1.41,1.41,0,0,0,1.5,1.26,1.34,1.34,0,0,0,1.3-1.42,1.39,1.39,0,0,0-1.5-1.26A1.35,1.35,0,0,0,130.86,278.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38,277.31c.2.16,1.17-.74,2.67-.9s2.69.47,2.83.27-.14-.4-.66-.7a4,4,0,0,0-2.29-.44,3.71,3.71,0,0,0-2.1.95C130.41,276.89,130.29,277.24,130.38,277.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,277.58a1.41,1.41,0,0,0,1.51,1.26,1.35,1.35,0,0,0,1.3-1.42,1.4,1.4,0,0,0-1.5-1.26A1.35,1.35,0,0,0,145.61,277.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.18,276c.2.16,1.17-.74,2.67-.9s2.69.47,2.83.27-.14-.4-.66-.7a4,4,0,0,0-2.29-.44,3.71,3.71,0,0,0-2.1.95C145.21,275.54,145.09,275.89,145.18,276Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,287.7a10.61,10.61,0,0,0-2.49-.17c-.39,0-.76,0-.85-.28a2,2,0,0,1,.13-1.17c.26-1,.53-2,.81-3.05,1.12-4.33,1.88-7.88,1.71-7.92s-1.23,3.43-2.34,7.77c-.27,1.06-.52,2.08-.77,3.06a2.25,2.25,0,0,0,0,1.52,1,1,0,0,0,.69.5,3,3,0,0,0,.67,0A9.27,9.27,0,0,0,141,287.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,288.26c-.25,0-.07,1.64-1.34,2.95s-3,1.33-3,1.55.42.28,1.15.22a4.09,4.09,0,0,0,2.53-1.21,3.6,3.6,0,0,0,1-2.46C145.83,288.62,145.61,288.23,145.5,288.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15,270.12c.19.39,1.67,0,3.45.05s3.27.34,3.46-.05c.09-.19-.2-.55-.82-.88a6,6,0,0,0-5.27,0C144.35,269.57,144.06,269.93,144.15,270.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.46,272.9c.3.31,1.29-.16,2.54-.31s2.32,0,2.52-.41c.09-.18-.11-.51-.61-.78a3.56,3.56,0,0,0-2.13-.33,3.49,3.49,0,0,0-1.95.91C130.43,272.38,130.32,272.75,130.46,272.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.66,279.35c.16-.09,6.5-2.73,7,4s-6.32,5.85-6.34,5.65S161.66,279.35,161.66,279.35Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.19,286.28s.12.08.33.15a1.17,1.17,0,0,0,.87-.05,2.9,2.9,0,0,0,1.14-2.7,4.12,4.12,0,0,0-.46-1.65,1.36,1.36,0,0,0-.95-.82.6.6,0,0,0-.67.37c-.07.2,0,.33,0,.34s-.16-.1-.12-.38a.68.68,0,0,1,.23-.44.84.84,0,0,1,.63-.22,1.63,1.63,0,0,1,1.3.94,3.9,3.9,0,0,1,.55,1.84,3,3,0,0,1-1.47,3,1.24,1.24,0,0,1-1.09-.1C164.21,286.44,164.16,286.3,164.19,286.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,278.71a3.54,3.54,0,0,0-3,2c-.33,1-.31,2.1-.64,3.1s-1.21,2-2.26,1.85a2.09,2.09,0,0,1-1.56-1.38,5.53,5.53,0,0,1-.25-2.15c0-3.16.36-6.33.14-9.49a16.12,16.12,0,0,0-3-8.87,8.81,8.81,0,0,0-8.3-3.53c-2.06.39-3.85,1.69-5.88,2.2a8.18,8.18,0,0,1-7-1.51,15.52,15.52,0,0,0-1.37-.77,3.88,3.88,0,0,1,.47-2.15c3.68-4.24,10.94-6.11,16.5-5.34a19.62,19.62,0,0,1,13.94,8.83c2.88,4.81,3,11.94,2.25,17.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.09,433s72.21-47.36,75.17-48.35,10.1-5.67,17.25-3.7,13.55,8.38,16.75,17.74S168.71,429,168.71,429,163,445.5,152,449a26.53,26.53,0,0,1-2.89.72c-13.54,2.69-27.3-3.53-34.87-15.07l-1.62-2.45s-47.23,17.35-48,17.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.47,377.74s-8.84,3.15-8.87,13.06c-.07,19,38.33,39.89,38.33,39.89L112,396.82v-3.56S46.25,369.61,31.47,377.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.43,420s-.13.07-.4.18l-1.18.47-4.58,1.76-17,6.41c-7.23,2.69-15.89,5.9-25.6,9.43s-20.47,7.41-32,11.3l-.21.07-.1-.19c-1.81-3.45-3.71-7.08-5.64-10.78l-2.88-5.49-.11-.21.2-.13,55.08-35,16.55-10.44,4.49-2.8,1.17-.72.41-.23a4.53,4.53,0,0,1-.38.27l-1.14.76-4.45,2.88-16.46,10.58-55,35.1.09-.34c.92,1.74,1.89,3.61,2.88,5.49l5.64,10.78-.31-.13c11.49-3.88,22.25-7.74,32-11.24l25.63-9.33,17.07-6.26,4.6-1.67,1.2-.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.15,413.93a11.72,11.72,0,0,1-1.33-.91c-.84-.6-2-1.51-3.5-2.64-2.92-2.26-6.9-5.46-11.19-9.14s-8-7.13-10.73-9.68c-1.34-1.28-2.41-2.32-3.14-3.06a9.74,9.74,0,0,1-1.09-1.18,11.51,11.51,0,0,1,1.23,1l3.25,2.93c2.74,2.48,6.55,5.88,10.82,9.55s8.22,6.92,11.08,9.25l3.39,2.77A9.43,9.43,0,0,1,86.15,413.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,384.83a10,10,0,0,1,4.92.45,10.14,10.14,0,0,1,4.38,2.3c-.09.13-2-1.05-4.53-1.8S45.89,385,45.9,384.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3,381.84a6.23,6.23,0,0,1,3,2.28,6.15,6.15,0,0,1,1.59,3.44c-.15.05-.71-1.54-2-3.11S50.22,382,50.3,381.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.66,441.92c0-.06.61-.19,1.31.4a4.72,4.72,0,0,1,1.48,3,5.9,5.9,0,0,1-.46,3.27c-.37.78-.76,1.14-.81,1.11s.21-.48.46-1.24a6.76,6.76,0,0,0,.3-3.07,5.17,5.17,0,0,0-1.21-2.76A3.54,3.54,0,0,0,28.66,441.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-99"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.11,
    y: 387.4,
    width: 69.76,
    height: 9.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,397.1H383v-9.82h70Zm-69.76-.24h69.52v-9.34H383.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.58 393.79 399.62 443.33 436.78 443.33 446.48 396.98 389.58 393.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.58 438.64 394.94 446.01 440.1 446.01 446.48 438.64 389.58 438.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,395.24c-.13,0-.31-22.95-.39-51.25s0-51.26.11-51.26.31,22.94.39,51.25S415.51,395.24,415.37,395.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.91,337.81a2.24,2.24,0,0,1-.18.53c-.17.39-.37.88-.63,1.49-.14.32-.29.68-.45,1.07l-.47,1.3c-.16.47-.34,1-.53,1.49s-.34,1.11-.52,1.71a69,69,0,0,0-1.95,8.54,102.72,102.72,0,0,0-1.08,10.68,144,144,0,0,0,.55,19.51c.23,2.49.45,4.5.62,5.89.07.66.13,1.19.17,1.61a2,2,0,0,1,0,.56,2.41,2.41,0,0,1-.13-.55c-.07-.42-.16-.94-.26-1.59-.23-1.38-.51-3.39-.78-5.88a128.65,128.65,0,0,1-.7-19.57,98.2,98.2,0,0,1,1.13-10.74,66.09,66.09,0,0,1,2.06-8.57c.2-.59.36-1.17.56-1.7l.57-1.49.51-1.29c.17-.39.35-.74.5-1.06l.71-1.45A2.41,2.41,0,0,1,430.91,337.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.13,319.25a4.4,4.4,0,0,1-.22.75l-.73,2.14-.53,1.53c-.17.58-.36,1.2-.56,1.86-.41,1.33-.88,2.83-1.3,4.53-.23.85-.46,1.73-.7,2.66s-.43,1.9-.66,2.9c-.48,2-.84,4.17-1.29,6.43-.76,4.56-1.44,9.6-1.91,14.91s-.63,10.41-.7,15,.05,8.79.24,12.28c.06,1.75.17,3.33.26,4.72s.17,2.58.26,3.56.12,1.68.17,2.24a4.28,4.28,0,0,1,0,.79,4,4,0,0,1-.12-.78c-.07-.55-.16-1.3-.27-2.24s-.23-2.16-.34-3.55-.25-3-.34-4.72c-.23-3.49-.33-7.67-.34-12.3s.22-9.73.67-15.07,1.16-10.38,1.95-14.95c.47-2.27.83-4.44,1.34-6.44.24-1,.46-2,.68-2.91s.5-1.8.74-2.65c.44-1.7.94-3.2,1.37-4.53l.6-1.84c.21-.56.41-1.06.58-1.53.34-.88.61-1.58.82-2.1A4.12,4.12,0,0,1,429.13,319.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,399.3a1.14,1.14,0,0,1,0-.27c0-.21,0-.47-.06-.79-.05-.73-.12-1.75-.21-3-.17-2.68-.4-6.48-.7-11.18-.6-9.43-1.48-22.47-3.07-36.81-.81-7.17-1.75-14-2.73-20.15-.52-3.08-1-6-1.52-8.74s-1-5.27-1.51-7.58-1-4.4-1.38-6.23-.8-3.4-1.12-4.68-.55-2.25-.73-3c-.07-.32-.13-.57-.17-.77a1.14,1.14,0,0,1-.05-.27.9.9,0,0,1,.09.25c.06.2.14.45.23.76.19.71.47,1.69.81,2.94s.78,2.84,1.21,4.67,1,3.9,1.45,6.22,1.06,4.84,1.57,7.57,1,5.67,1.57,8.75c1,6.17,2,13,2.78,20.17,1.59,14.35,2.41,27.4,2.92,36.84.26,4.73.44,8.55.54,11.19.05,1.3.09,2.31.12,3.05,0,.32,0,.58,0,.79A1.1,1.1,0,0,1,411,399.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.81,303.76c-.31-3.25-3.59-5.7-6.86-5.74s-6.31,1.93-8.3,4.51a25.88,25.88,0,0,0-4,8.88c-2.2,7.66-3.4,15.7-2.46,23.62s4.15,15.7,9.83,21.29c.92.91,2.11,1.82,3.38,1.55a4.19,4.19,0,0,0,1.79-1.1,52.89,52.89,0,0,0,17.15-40.2c-.08-3-.48-6.14-2.15-8.65s-5.55-5.17-8.38-4.16",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.42,277.72l-4.6,8.33c-.1.19-.24.41-.47.43s-.42-.21-.55-.41l-12.16-18.66,2.8-1.59Z",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.42,277.72l-4.6,8.33c-.1.19-.24.41-.47.43s-.42-.21-.55-.41l-12.16-18.66,2.8-1.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M415.09,292.73l-41.48-24.48a1.94,1.94,0,0,1-1-1c-.16-.61.3-1.2.74-1.66a28.62,28.62,0,0,1,22.16-8.71,25.31,25.31,0,0,1,20,12.47c4,7.15,4.14,16.61-.45,23.4",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.59,260.44a2.07,2.07,0,0,1,.54-.07c.36,0,.89-.08,1.57-.07a30.54,30.54,0,0,1,5.75.45,34.06,34.06,0,0,1,17,8.2A34.26,34.26,0,0,1,414.3,285a31.89,31.89,0,0,1,1,5.69c.07.67.06,1.2.08,1.56a1.8,1.8,0,0,1,0,.55s-.09-.75-.26-2.09a34,34,0,0,0-27.74-29.65,36,36,0,0,0-5.69-.61C380.34,260.46,379.59,260.48,379.59,260.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.47,275.83a9,9,0,0,1-2.09,1c-1.33.52-3.17,1.18-5.24,1.84s-4,1.18-5.34,1.51a10.54,10.54,0,0,1-2.26.44,10.91,10.91,0,0,1,2.17-.77l5.28-1.65,5.27-1.7A11.94,11.94,0,0,1,409.47,275.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.94,258.29a29.24,29.24,0,0,1,.24,9.27,28.77,28.77,0,0,1-.25-4.63A29.1,29.1,0,0,1,402.94,258.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,267.79a17.86,17.86,0,0,1,3-1.06c1.89-.58,4.51-1.32,7.44-2s5.59-1.25,7.54-1.59a19.62,19.62,0,0,1,3.16-.43,21.6,21.6,0,0,1-3.1.78c-1.92.42-4.57,1-7.49,1.72s-5.55,1.38-7.45,1.88A22.43,22.43,0,0,1,373.25,267.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,296.06c-3.56-2.7-7.34-3.23-11.81-3.06a36.1,36.1,0,0,0-12.93,3.34c-7,3.06-13.57,7.58-17.74,14s-5.64,14.85-2.51,21.81a3.09,3.09,0,0,0,1.42,1.72,3.35,3.35,0,0,0,2.34-.18c7.95-2.59,16-5.21,23.28-9.28s14-9.71,17.89-17.1a14.8,14.8,0,0,0,1.89-5.67,7.07,7.07,0,0,0-1.83-5.55",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,295.22a2.38,2.38,0,0,1-.57.24l-1.67.57-1.2.4c-.44.16-.91.36-1.41.55-1,.41-2.18.82-3.41,1.41l-1.95.89c-.67.31-1.35.7-2.06,1.06-1.45.71-2.91,1.61-4.46,2.53a70.6,70.6,0,0,0-17.55,15.44c-1.1,1.42-2.19,2.76-3.07,4.1-.46.66-.92,1.28-1.32,1.91l-1.13,1.82c-.75,1.15-1.3,2.25-1.83,3.2-.26.48-.51.91-.73,1.33l-.55,1.14-.78,1.58a3.11,3.11,0,0,1-.3.54,2.22,2.22,0,0,1,.21-.58l.7-1.62c.15-.36.33-.74.51-1.17s.44-.86.69-1.35c.51-1,1.05-2.09,1.78-3.25l1.11-1.85c.39-.64.85-1.27,1.3-1.94.87-1.36,2-2.71,3.06-4.15a74.76,74.76,0,0,1,8.15-8.54,75.58,75.58,0,0,1,9.51-7c1.57-.91,3.05-1.81,4.51-2.5.72-.36,1.4-.74,2.09-1.05l2-.86c1.25-.58,2.43-1,3.45-1.35.51-.18,1-.37,1.43-.51l1.22-.36,1.7-.49A5.18,5.18,0,0,1,396,295.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.16,310.31a79.68,79.68,0,0,1-8.67,2.8,85,85,0,0,1-8.82,2.32,86,86,0,0,1,8.68-2.8A85.93,85.93,0,0,1,368.16,310.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.81,329.46a13.11,13.11,0,0,1-.19-2.7c-.05-1.67-.06-4,0-6.53s.2-4.86.34-6.53a15.07,15.07,0,0,1,.34-2.69,15.35,15.35,0,0,1,0,2.71c-.05,1.83-.12,4.06-.2,6.52s-.12,4.69-.16,6.52A16.19,16.19,0,0,1,367.81,329.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.21,321.11c-.14,0-.57-4.69-1-10.49s-.62-10.51-.48-10.52.57,4.68,1,10.49S384.35,321.1,384.21,321.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.79,299.64a17.18,17.18,0,0,1,2.78-.08c1.72,0,4.09.06,6.7.15s5,.19,6.69.29a15,15,0,0,1,2.77.27,14.57,14.57,0,0,1-2.78.08c-1.71,0-4.08-.06-6.7-.14s-5-.2-6.69-.3A15,15,0,0,1,363.79,299.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.79,358.56a4.45,4.45,0,0,1-.06-.57c0-.43,0-1-.07-1.63-.06-1.41-.08-3.47,0-6s.21-5.55.51-8.88.79-7,1.46-10.81,1.51-7.4,2.36-10.64,1.76-6.12,2.59-8.52,1.54-4.31,2.09-5.62l.63-1.5a2.87,2.87,0,0,1,.25-.51,1.91,1.91,0,0,1-.15.54c-.15.41-.33.91-.55,1.54-.49,1.33-1.16,3.26-1.94,5.66s-1.63,5.29-2.48,8.52-1.63,6.83-2.31,10.62-1.15,7.44-1.49,10.76-.53,6.33-.62,8.85-.14,4.57-.13,6c0,.66,0,1.2,0,1.63A2.34,2.34,0,0,1,404.79,358.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,330.26a11.23,11.23,0,0,1-1.65,1.81c-1.08,1.07-2.6,2.51-4.34,4s-3.36,2.85-4.56,3.78a11.68,11.68,0,0,1-2,1.4,12.8,12.8,0,0,1,1.8-1.68l4.45-3.87,4.43-3.91A13,13,0,0,1,407,330.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.11,340.83a18.35,18.35,0,0,1-1.76-2.44c-1.14-1.65-2.54-3.71-4.1-6s-3-4.28-4.18-5.92a18.87,18.87,0,0,1-1.68-2.5,17.11,17.11,0,0,1,2,2.29c1.15,1.46,2.69,3.52,4.31,5.85s3,4.49,4,6.07A17.25,17.25,0,0,1,420.11,340.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.23,307.58c.08.11-4.28,3.05-9.74,6.55s-9.93,6.26-10,6.14,4.29-3,9.74-6.56S413.16,307.46,413.23,307.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.53,320.85a79.76,79.76,0,0,1-6.6-6.1,83.11,83.11,0,0,1-6.25-6.45,79.76,79.76,0,0,1,6.6,6.1A80.9,80.9,0,0,1,425.53,320.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,320.58l3.75-.31a18.61,18.61,0,0,0,7.55-2.31,29.84,29.84,0,0,1,3.53-1.77c4.63-1.86,9.79-1.53,14.77-1.78a61.09,61.09,0,0,0,23.5-6,2.21,2.21,0,0,0,1-.93c.77-1.4-.66-2.65-1.89-3.4-6.31-3.89-12.73-7.82-19.88-9.75s-15.27-1.61-21.37,2.59c-7.17,4.93-9.78,15.06-11,23.67",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.83,307a2.91,2.91,0,0,1-.63-.29l-1.78-.93c-1.54-.81-3.75-2-6.55-3.35a60.83,60.83,0,0,0-10.15-3.91,33.5,33.5,0,0,0-13.14-1.06,22.46,22.46,0,0,0-12,5.14,26.74,26.74,0,0,0-6.24,8.77,72.08,72.08,0,0,0-2.72,6.83c-.27.78-.5,1.41-.66,1.88a2.87,2.87,0,0,1-.27.65,6.42,6.42,0,0,1,.17-.68c.15-.48.34-1.12.58-1.91a60.19,60.19,0,0,1,2.58-6.92,26.5,26.5,0,0,1,6.26-9,22.73,22.73,0,0,1,12.22-5.3,33.48,33.48,0,0,1,13.34,1.12,58.47,58.47,0,0,1,10.17,4c2.79,1.38,5,2.63,6.5,3.49l1.73,1A4.5,4.5,0,0,1,482.83,307Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.84,311.84c-.08.12-5-3-10.93-7.07s-10.74-7.37-10.66-7.49,5,3.06,10.93,7.08S473.92,311.73,473.84,311.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.14,296.82a11.61,11.61,0,0,1-3.82.76,11.86,11.86,0,0,1-3.9-.05,20.8,20.8,0,0,1,3.85-.44A21.64,21.64,0,0,1,469.14,296.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.19,292.88a13.77,13.77,0,0,1-1.61,3.21,13.53,13.53,0,0,1-2,3,25.48,25.48,0,0,1,3.64-6.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.57,314.73a13.55,13.55,0,0,1-2.35-1.28c-1.42-.86-3.33-2.12-5.37-3.6s-3.84-2.89-5.14-3.91a15.46,15.46,0,0,1-2-1.74,13,13,0,0,1,2.24,1.46l5.22,3.79c2,1.48,3.91,2.77,5.27,3.7A16.18,16.18,0,0,1,451.57,314.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.13,336.49c-3.57-.95-7.82,2.53-8.56,6.15s.62,7.32,2.21,10.65a54.36,54.36,0,0,0,14.77,19.32c6.39,5.09,14.4,8.35,22.57,8.31-1.51-7,.4-14.34-.44-21.46A27.92,27.92,0,0,0,440,335c-2.28-.24-4.92-.6-5.83,1.51",
    style: {
      fill: "#990E3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.12,380.92a2.35,2.35,0,0,1-.5-.24,8.18,8.18,0,0,1-1.34-.89,14,14,0,0,1-3.53-4.72c-.56-1.1-1.2-2.3-1.82-3.63s-1.25-2.76-1.92-4.25a41.07,41.07,0,0,0-2.36-4.54,36.51,36.51,0,0,0-3.25-4.42c-2.45-2.87-5.07-5.35-7.34-7.72a50.93,50.93,0,0,1-5.6-6.72,25.44,25.44,0,0,1-2.74-5.22,15.1,15.1,0,0,1-.47-1.54,3.57,3.57,0,0,1-.12-.54c.05,0,.25.73.77,2a27.2,27.2,0,0,0,2.85,5.09,53.39,53.39,0,0,0,5.63,6.6c2.29,2.34,4.93,4.82,7.4,7.72a35.92,35.92,0,0,1,3.28,4.49,40.16,40.16,0,0,1,2.36,4.6l1.88,4.27c.6,1.32,1.22,2.53,1.77,3.64a14.36,14.36,0,0,0,3.33,4.73C464.45,380.54,465.15,380.87,465.12,380.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.66,375.09a11.19,11.19,0,0,1,.33-2.4c.28-1.47.74-3.49,1.35-5.69s1.29-4.16,1.82-5.56a10.54,10.54,0,0,1,1-2.22,12.9,12.9,0,0,1-.64,2.34c-.44,1.42-1.05,3.39-1.67,5.58s-1.12,4.18-1.49,5.63A13.12,13.12,0,0,1,446.66,375.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,357.88a14.28,14.28,0,0,1-2.52-.57c-1.54-.41-3.66-1-6-1.49s-4.52-.95-6.09-1.24a15.13,15.13,0,0,1-2.52-.56,12.47,12.47,0,0,1,2.58.21c1.58.21,3.76.57,6.13,1.11s4.5,1.14,6,1.63A12.6,12.6,0,0,1,464.45,357.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.41,362.88a13.78,13.78,0,0,1,.39-2.78c.31-1.7.81-4.05,1.48-6.61s1.38-4.85,1.93-6.49a13.5,13.5,0,0,1,1-2.61,18.77,18.77,0,0,1-.69,2.72c-.47,1.66-1.13,4-1.79,6.51s-1.22,4.87-1.62,6.56A16.4,16.4,0,0,1,433.41,362.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.26,342.89c0,.13-4.48-.23-10-.81a98.49,98.49,0,0,1-9.9-1.3,97.07,97.07,0,0,1,10,.81A99,99,0,0,1,456.26,342.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,396.94c0,.14-15.67.25-35,.25s-35-.11-35-.25,15.66-.25,35-.25S453,396.81,453,396.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.09,417.11c0,.13-10.56.25-23.58.25s-23.58-.12-23.58-.25,10.56-.25,23.58-.25S442.09,417,442.09,417.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5,420c0,.14-10.56.25-23.58.25s-23.58-.11-23.58-.25,10.56-.25,23.58-.25S442.5,419.85,442.5,420Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5,414.73c0,.14-10.92.25-24.39.25s-24.39-.11-24.39-.25,10.92-.25,24.39-.25S442.5,414.59,442.5,414.73Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateOwner);
export default __webpack_public_path__ + "static/media/updateOwner.7c1dea0c7d87bcb191e033de5d08f8b1.svg";
export { ForwardRef as ReactComponent };